import { takeLatest, put, call } from 'redux-saga/effects';
import { UPLOAD_MONITORING_OLD_DATA_REQUEST, uploadMonitoringDataResponse, MONITORING_DOWNLOAD_COUNTERPARTY_DATA_REQUEST, downloadMonitoringCounterpartyDataResponse,
FETCH_MONITORING_LIST_REQUEST, fetchMonitoringListResponse, CREATE_MONITORING_METADATA_REQUEST, createMonitoringMetaDataResponse,
UPLOAD_MONITORING_DATA_REQUEST, startMonitoringProcessResponse, DOWNLOAD_MONITORING_CRAWLER_STATUS_FILE_REQUEST, downloadMonitoringCrawlerStatusFileResponse, 
DOWNLOAD_CONSOLIDATED_MONITORING_REPORT_REQUEST, downloadConsolidatedMonitoringReportResponse, STOP_MONITORING_REQUEST , stopMonitoringResponse, 
INITIATE_MONITORING_REQUEST, initiateMonitoringResponse, UPLOAD_MONITORING_TEMPLATE_REQUEST, uploadMonitoringTemplateResponse, CORPORATE_MONITORING_DATA_REQUEST, fetchCorporateMonitoringResponse,
MONITORING_CORPORATE_LIST_REQUEST, fetchMonitoringCorporateListResponse,PUBLISH_MONITORING_REPORT_REQUEST, publishMonitoringReportResponse,
DOWNLOAD_CORPORATE_MONITORING_REPORT_REQUEST, downloadCorporateMonitoringReportResponse, DOWNLOAD_MONITORING_SCORE_CALCULATION_TEMPLATE_REQUEST, downloadMonitoringScoreCalcultionTemplateResponse,
downlodOldOrOfflineDataUploadTemplateResponse, downloadEWSReportResponse, DOWNLOAD_EWS_REPORT_REQUEST, DOWNLOAD_OLD_OR_OFFLINE_UPLOAD_TEMPLATE_REQUEST,SEND_CORPORATE_MONITORING_REPORT_REQUEST,
sendCorporateMonitoringReportResponse,SEND_MONITORING_BULK_REPORT_REQUEST,sendCorporateMonitoringBulkReportResponse, EWS_PUBLISH_LIST_REQUEST, ewsPublishListResponse, fetchCorporateEwsResponse,
CORPORATE_EWS_DATA_REQUEST} from './action';
import { CORE_API, EWS_API } from '../../../config';
import { HTTP_HEADERS, HTTP_HEADERS_CONTENT_TYPE_FILE, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER,  HTTP_RESPONSE_TYPE_ARRAYBUFFER} from '../../../constants'
import request from "../../../components/Utils/httpHelper";


export function* uploadMonitoringDataRequest(action){
    let requestURL = `${CORE_API}/monitoring/data/upload`;
    const formData = new FormData();
    formData.append('monitoringId', action.data.monitoringId)
    formData.append('file', action.data.file);
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: HTTP_HEADERS });
        yield put(uploadMonitoringDataResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(uploadMonitoringDataResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* uploadMonitoringData() {
    yield takeLatest(UPLOAD_MONITORING_OLD_DATA_REQUEST, uploadMonitoringDataRequest);
}

export function* downloadMonitoringCounterpartyDataRequest(action){
    let requestURL = `${CORE_API}/monitoring/complete-data`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', params : {"fromDate" : action.data.fromDate, "toDate" : action.data.toDate}, headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadMonitoringCounterpartyDataResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(downloadMonitoringCounterpartyDataResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* downloadMonitoringCounterpartyData() {
    yield takeLatest(MONITORING_DOWNLOAD_COUNTERPARTY_DATA_REQUEST, downloadMonitoringCounterpartyDataRequest);
}


export function* fetchMonitoringListRequest(action){
    let requestURL = `${CORE_API}/monitoring/monitoring-list`;
    if(action && action.data && action.data.corporateId && action.data.corporateId.trim().length > 0){
        requestURL = `${requestURL}/${action.data.corporateId}`;
    }
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS});
        yield put(fetchMonitoringListResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(fetchMonitoringListResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* fetchMonitoringList() {
    yield takeLatest(FETCH_MONITORING_LIST_REQUEST, fetchMonitoringListRequest);
}


export function* createMonitoringMetadataRequest(action){
    let requestURL = `${CORE_API}/monitoring/create-monitoring-metadata`;
    try {
        const data = yield call(request, requestURL, { method: 'post', params : { monitoringName : action.data.monitoringName, monitoringDate : action.data.monitoringDate }, headers: HTTP_HEADERS});
        yield put(createMonitoringMetaDataResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(createMonitoringMetaDataResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* createMonitoringMetadata() {
    yield takeLatest(CREATE_MONITORING_METADATA_REQUEST, createMonitoringMetadataRequest);
}

//startMonitoringProcessResponse


export function* startMonitoringProcessRequest(action){
    let requestURL = `${CORE_API}/monitoring/monitoring-start`;
    const formData = new FormData();
    formData.append('monitoringId', action.data.monitoringId)
    formData.append('file', action.data.file);
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: HTTP_HEADERS });
        yield put(startMonitoringProcessResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(startMonitoringProcessResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* startMonitoringProcess() {
    yield takeLatest(UPLOAD_MONITORING_DATA_REQUEST, startMonitoringProcessRequest);
}



export function* downloadConsolidatedMonitoringReportRequest(action){
    let requestURL = `${CORE_API}/monitoring/report/${action.data.monitoringId}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadConsolidatedMonitoringReportResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(downloadConsolidatedMonitoringReportResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* downloadConsolidatedMonitoringReport() {
    yield takeLatest(DOWNLOAD_CONSOLIDATED_MONITORING_REPORT_REQUEST, downloadConsolidatedMonitoringReportRequest);
}


export function* downloadMonitoringCrawlerStatusFileRequest(action){
    let requestURL = `${CORE_API}/monitoring/crawler-status/${action.data.monitoringId}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadMonitoringCrawlerStatusFileResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(downloadMonitoringCrawlerStatusFileResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* downloadMonitoringCrawlerStatusFile() {
    yield takeLatest(DOWNLOAD_MONITORING_CRAWLER_STATUS_FILE_REQUEST, downloadMonitoringCrawlerStatusFileRequest);
}


export function* uploadMonitoringTemplateRequest(action){
    let requestURL = `${CORE_API}/monitoring/upload/template`;
    const formData = new FormData();
    formData.append('monitoringId', action.data.monitoringId)
    formData.append('file', action.data.file);
    formData.append('gstDropDownValue', action.data.gstDropDownValue);
    formData.append('mcaDropDownValue', action.data.mcaDropDownValue);
    formData.append('epfDropDownValue', action.data.epfDropDownValue);
    formData.append('ratingDropDownValue', action.data.ratingDropDownValue);
    formData.append('legalDropDownValue', action.data.legalDropDownValue);
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: HTTP_HEADERS });
        if(data && data.status == "200" ){
            yield put(uploadMonitoringTemplateResponse({ data : data.data , status : "SUCCESS"}));
        }else{
            yield put(uploadMonitoringTemplateResponse({ data : data.data , status :  "FAILURE"}));
        }
    }
    catch (err) {
        yield put(uploadMonitoringTemplateResponse( { ...err.response , status : "FAILURE"}))
    }
}
 
export function* uploadMonitoringTemplateProcess() {
    yield takeLatest(UPLOAD_MONITORING_TEMPLATE_REQUEST, uploadMonitoringTemplateRequest);
}
 
export function* initiateMonitoringRequest(action){
    let requestURL = `${CORE_API}/monitoring/start`;
    const formData = new FormData();
    formData.append('monitoringId', action.data.monitoringId)
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: HTTP_HEADERS });
        yield put(initiateMonitoringResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(initiateMonitoringResponse( { ...err.response , status : "FAILURE"}))
    }
}
 
export function* initiateMonitoringProcess() {
    yield takeLatest(INITIATE_MONITORING_REQUEST, initiateMonitoringRequest);
}
 
export function* stopMonitoringRequest(action){
    let requestURL = `${CORE_API}/monitoring/stop`;
    const formData = new FormData();
    formData.append('monitoringId', action.data.monitoringId)
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: HTTP_HEADERS });
        yield put(stopMonitoringResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(stopMonitoringResponse( { ...err.response , status : "FAILURE"}))
    }
}
 
export function* stopMonitoringProcess() {
    yield takeLatest(STOP_MONITORING_REQUEST, stopMonitoringRequest);
}


export function* fetchCorporateMonitoringRequest(action){
    let requestURL = `${CORE_API}/monitoring/graph/${action.data.type}/${action.data.monitoringId}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS});
        yield put(fetchCorporateMonitoringResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(fetchCorporateMonitoringResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* fetchCorporateMonitoring() {
    yield takeLatest(CORPORATE_MONITORING_DATA_REQUEST, fetchCorporateMonitoringRequest);
}


export function* fetchMonitoringCorporateListRequest(action){
    let requestURL = `${CORE_API}/monitoring/corporate-list/${action.data.monitoringId}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS});
        yield put(fetchMonitoringCorporateListResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(fetchMonitoringCorporateListResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* fetchMonitoringCorporateList() {
    yield takeLatest(MONITORING_CORPORATE_LIST_REQUEST, fetchMonitoringCorporateListRequest);
}


export function* downloadCorporateMonitoringReportRequest(action){
    let requestURL = `${CORE_API}/monitoring/report/monitoringid/${action.data.monitoringId}/corporate/${action.data.corporateId}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadCorporateMonitoringReportResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(downloadCorporateMonitoringReportResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* downloadCorporateMonitoringReport() {
    yield takeLatest(DOWNLOAD_CORPORATE_MONITORING_REPORT_REQUEST, downloadCorporateMonitoringReportRequest);
}

export function* downloadCorporateEWSReportRequest(action){
    let requestURL = `${CORE_API}/ews/report?corporateId=${action.data.corporateId}&publishId=${action.data.publishId}&fromDate=${action.data.fromDate}&isPortfolio=${action.data.isPortfolio}&publishName=${action.data.publishName}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadEWSReportResponse({ data : data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(downloadEWSReportResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* downloadCorporateEWSReport() {
    yield takeLatest(DOWNLOAD_EWS_REPORT_REQUEST, downloadCorporateEWSReportRequest);
}

export function* ewsPublishListRequest(action){
    let requestURL = `${EWS_API}/publish/corporate?corporateId=${action.data.corporateId}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(ewsPublishListResponse({ data : data.data , status : "SUCCESS"}))
    }catch (err) {
        yield put(ewsPublishListResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* ewsPublishList() {
    yield takeLatest(EWS_PUBLISH_LIST_REQUEST, ewsPublishListRequest);
}

export function* fetchCorporateEwsRequest(action){
    let requestURL = `${EWS_API}/publish/graph/${action.data.type}/${action.data.publishId}/${action.data.isPortfolio}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS});
        yield put(fetchCorporateEwsResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(fetchCorporateEwsResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* fetchCorporateEws() {
    yield takeLatest(CORPORATE_EWS_DATA_REQUEST, fetchCorporateEwsRequest);
}

export function* sendCorporateMonitoringReportRequest(action){
    let requestURL = `${CORE_API}/monitoring/corporateWiseMail/${action.data.monitoringId}/${action.data.corporateId}`;
    const formData = new FormData();
    formData.append('monitoringId', action.data.monitoringId)
    formData.append('corporateId', action.data.corporateId);
    try {
        const data = yield call(request, requestURL, { method: 'POST',headers: HTTP_HEADERS });
        yield put(sendCorporateMonitoringReportResponse({ data : data.data , status : "SUCCESS" }))
    }
    catch (err) {
        yield put(sendCorporateMonitoringReportResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* sendCorporateMonitoringReport() {
    yield takeLatest(SEND_CORPORATE_MONITORING_REPORT_REQUEST, sendCorporateMonitoringReportRequest);
}

export function* sendCorporateMonitoringBulkReportRequest(action){
    let requestURL = `${CORE_API}/monitoring/bulkMail/${action.data.monitoringId}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'POST',headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(sendCorporateMonitoringBulkReportResponse({ data : data.data , status : "SUCCESS" }))
    }
    catch (err) {
        yield put(sendCorporateMonitoringBulkReportResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* sendMonitoringBulkReport() {
    yield takeLatest(SEND_MONITORING_BULK_REPORT_REQUEST, sendCorporateMonitoringBulkReportRequest);
}
export function* downloadMonitoringScoreCalcultionTemplateRequest(action){
    let requestURL = `${CORE_API}/monitoring/download/template/${action.data.monitoringId}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadMonitoringScoreCalcultionTemplateResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(downloadMonitoringScoreCalcultionTemplateResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* downloadMonitoringScoreCalcultionTemplate() {
    yield takeLatest(DOWNLOAD_MONITORING_SCORE_CALCULATION_TEMPLATE_REQUEST, downloadMonitoringScoreCalcultionTemplateRequest);
}

export function* publishMonitoringReportRequest(action){
    let requestURL = `${CORE_API}/monitoring/publish-report/${action.data.monitoringId}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'post', params : { publishReport : action.data.publishReport }, headers: HTTP_HEADERS});
        yield put(publishMonitoringReportResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(publishMonitoringReportResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* publishMonitoringReport() {
    yield takeLatest(PUBLISH_MONITORING_REPORT_REQUEST, publishMonitoringReportRequest);
}

export function* downlodOldOrOfflineDataUploadTemplateRequest(action){
    let requestURL = `${CORE_API}/monitoring/download-offline-data-upload-template`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downlodOldOrOfflineDataUploadTemplateResponse({ data : data.data , status : "SUCCESS"}))
    }
    catch (err) {
        yield put(downlodOldOrOfflineDataUploadTemplateResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* downlodOldOrOfflineDataUploadTemplate() {
    yield takeLatest(DOWNLOAD_OLD_OR_OFFLINE_UPLOAD_TEMPLATE_REQUEST, downlodOldOrOfflineDataUploadTemplateRequest);
}
